//console.clear();
        const mainImageContainer = document.getElementById('ProductPhoto');
        console.log(`mainImageContainer: ${mainImageContainer}`)
        console.log(`${mainImageContainer}`)
        const openViewImg = document.createElement('img');
        console.log(`openViewImg: ${openViewImg}`)
        const selectedSwatch = document.querySelector('.mw-option__value--selected');
        console.log(`selectedSwatch: ${selectedSwatch}`)
        const state = {
            show: false,
            isEventAttached: false
        }


        const createElement = (tagName, className = null, style, attr = null) => {
            const element = document.createElement(tagName)
            if (className) {
                element.className = className
            }
            if (style) {
                element.style = style
            }
            if (attr) {
                element.setAttribute(attr.title, attr.value)
            }
            console.log(`element: ${element}`)
            return element
        }

        const toggleView = (show) => {
            const className = show ? 'openViewStyleImg' : 'hiddenImg'
            openViewImg.className = className
        }

        const tooggleButton = createElement('button', 'btn tooggleViewBtn', { position: 'absolute', top: 0, right: 0 }, {
            title: 'onclick',
            value: 'onBtnClick()'
        })

        window.initOpenView = function initOpenView(openView) {

            //console.log(`initOpenView`);
            //console.log(openView);
          
            const createOpenView = () => {
                openViewImg.src = openView
                openViewImg.className = 'hiddenImg'
                mainImageContainer.appendChild(openViewImg)
            }

            createOpenView()
//console.log(openViewImg.src);
            tooggleButton.innerText = 'Open view'
            window.onBtnClick = () => {
                state.show = !state.show
                state.isEventAttached = true
                tooggleButton.innerText = state.show ? 'Close view' : 'Open view'
                toggleView(state.show)
            }

            mainImageContainer.setAttribute('style', 'position: relative;')
            mainImageContainer.appendChild(tooggleButton)
        }

        window.resetOpenViewState = function resetOpenViewState() {
            state.show = false
            toggleView(state.show)
            tooggleButton.innerText = 'Open view'
        }
